<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="String(size)"
    :height="String(size)"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="yn-svg-icon yn-svg-icon-plus-circle"
  >
    <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [String, Number], default: '16' },
  strokeWidth: { type: [String, Number], default: 2 },
})
</script>
